import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { downloadImage } from "./downloadImage";
import { Alert, Box, CircularProgress } from "@mui/material";
import styles from "../../styles/style.module.scss";
import ReactPanZoom from "react-image-pan-zoom-rotate";

document.addEventListener('contextmenu', event => event.preventDefault());

export const ImageDownloader = () => {
  const { id } = useParams<{ id: string }>();
  const [status, setStatus] = useState<string | null>(null);
  const location = window.location.href;
  const [imageUrl, setImageUrl] = useState<string>('');

  useEffect(() => {
    localStorage.setItem("location", location);

    const fetchImage = async (id: string) => {
      try {
        setImageUrl(await downloadImage(id))
        setStatus("Файл успешно загружен");
      } catch (error) {
        setStatus("Не удалось загрузить файл");
      }
    };

    if (id) {
      fetchImage(id);
    }
  }, [id, location]);

  return (
    <div className={styles.centerBlock}>
      {status ? (
        <>
         <ReactPanZoom key={'image'} image={imageUrl} />
        </>
      ) : (
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      )}
    </div>
  );
};
